"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalCookieId = exports.getRandomAlpha = exports.getRandomInt = void 0;
const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
};
exports.getRandomInt = getRandomInt;
const getRandomAlpha = () => {
    return String.fromCharCode((0, exports.getRandomInt)(65, 91), (0, exports.getRandomInt)(65, 91), (0, exports.getRandomInt)(65, 91), (0, exports.getRandomInt)(65, 91), (0, exports.getRandomInt)(65, 91));
};
exports.getRandomAlpha = getRandomAlpha;
const getTotalCookieId = (cookieId) => {
    return `${cookieId}`;
};
exports.getTotalCookieId = getTotalCookieId;
